"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBetweenHours = exports.isLesserMonth = exports.isSameMonth = exports.getBusinessDate = exports.getPreviousMonth = exports.getOffsettedDate = exports.getCurrentDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var constants_1 = require("../constants");
/** 翌6時までは前日を当日として現在日を取得 */
var getCurrentDate = function () { return (0, dayjs_1.default)(new Date()).subtract(constants_1.TIME_OFFSET, "h").toDate(); };
exports.getCurrentDate = getCurrentDate;
/** 翌6時までは前日を当日としてdateの日付を取得 */
var getOffsettedDate = function (date) {
    return (0, dayjs_1.default)(date).subtract(constants_1.TIME_OFFSET, "h").toDate();
};
exports.getOffsettedDate = getOffsettedDate;
var getPreviousMonth = function (date) { return (0, dayjs_1.default)(date).subtract(1, "M").toDate(); };
exports.getPreviousMonth = getPreviousMonth;
/** 数字8桁でフォーマットした営業日付を返す */
var getBusinessDate = function (date) {
    return (0, dayjs_1.default)((0, exports.getOffsettedDate)(date)).format("YYYYMMDD");
};
exports.getBusinessDate = getBusinessDate;
/** date1とdate2が同じ月か(今月中などに使う) */
var isSameMonth = function (date1, date2) {
    return (0, dayjs_1.default)(date1).format("YYYYMM") === (0, dayjs_1.default)(date2).format("YYYYMM");
};
exports.isSameMonth = isSameMonth;
/** date1がdate2より小さい月か(先月以前などに使う) */
var isLesserMonth = function (date1, date2) {
    return (0, dayjs_1.default)(date1).format("YYYYMM") < (0, dayjs_1.default)(date2).format("YYYYMM");
};
exports.isLesserMonth = isLesserMonth;
/**
 * 現在時刻がその時間帯の範囲[start,end)に含まれるか判定
 * start,endには4桁の時刻を表す文字列HHmmを渡す
 */
var isBetweenHours = function (start, end) {
    var startNum = Number(start);
    var endNum = Number(end);
    var currentNum = Number((0, dayjs_1.default)().format("HHmm"));
    // 日付を跨ぐ場合
    if (startNum > endNum) {
        return currentNum < endNum || startNum <= currentNum;
    }
    else {
        return startNum <= currentNum && currentNum < endNum;
    }
};
exports.isBetweenHours = isBetweenHours;
//# sourceMappingURL=date.js.map